import React from "react";
import "./pull-quote.component.styles.scss";

import { useReveal } from "../../../lib/motion";

interface PullQuoteProps {
  /** The big italic quote — one short sentence */
  children: React.ReactNode;
  /** Small attribution below (e.g. "— Regina", or "Trattamento Ayurvedico · Arianna") */
  attribution?: string;
  /** Visual tone */
  tone?: "paper" | "ink";
}

// A statement set large and centred.
//
// History: this once held itself at opacity:0 until a local
// IntersectionObserver fired, and any scroll the observer failed to sample —
// a fast flick, an anchor jump, a screenshot pass — left the sentence
// permanently invisible. The scroll-reveal it uses now (src/lib/motion.ts +
// styles/base/_motion.scss) hides content only under html.lvs-js with motion
// allowed, and backstops the observer with viewport sweeps and a
// reveal-everything failsafe: the sentence can no longer be stranded.
const PullQuote: React.FC<PullQuoteProps> = ({ children, attribution, tone = "paper" }) => {
  const ref = useReveal<HTMLElement>();
  return (
    <section
      ref={ref}
      className={`lvs-quote lvs-quote--${tone} lvs-reveal lvs-reveal--fade`}
      aria-label="pull-quote"
    >
      <div className="lvs-quote__inner lvs-container">
        <blockquote className="lvs-quote__body">
          <p>{children}</p>
        </blockquote>
        {attribution && <p className="lvs-quote__attribution">{attribution}</p>}
      </div>
    </section>
  );
};

export default PullQuote;
